package com.swetdot.swetgram.cache

import kotlin.Long
import kotlin.String

public data class CachedMessage(
  public val chatId: String,
  public val clientId: String,
  public val serverId: String?,
  public val senderId: String,
  public val kind: String,
  public val text: String?,
  public val imageUrl: String?,
  public val voiceUrl: String?,
  public val voiceDurationMs: Long?,
  public val voiceWaveformJson: String?,
  public val replyToId: String?,
  public val replyToSenderId: String?,
  public val replyToSenderDisplayName: String?,
  public val replyToText: String?,
  public val replyToKind: String?,
  public val state: String,
  public val sentAt: Long,
  public val editedAt: Long?,
  public val isDeleted: Long,
  public val version: Long,
  public val canEdit: Long,
  public val canDeleteForEveryone: Long,
  public val reactionsJson: String?,
  public val picsoId: String?,
  public val picsoExpiresAt: String?,
  public val idempotencyKey: String?,
  public val retryCount: Long,
)
